<div class="not-load-component">
  <div class="icon">
    <i [ngClass]="icon" [style.color]="iconColor"></i>
  </div>
  <div class="content">
    <span class="title">{{ title | translate }}</span>
    <span class="description">{{ description | translate }}</span>
  </div>
  @if (isErrorState) {
    <div class="actions">
      <dk-button
        severity="primary"
        size="xlarge"
        [label]="primaryButtonText | translate"
        (onClick)="primaryButtonClick.emit($event)"></dk-button>
    </div>
  }
</div>
